var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4968 2.22086C17.7913 1.92638 18.2687 1.92638 18.5632 2.22086L21.7792 5.43685C22.0737 5.73132 22.0737 6.20876 21.7792 6.50324C21.4847 6.79772 21.0073 6.79772 20.7128 6.50324L19.6378 5.42827L18.563 6.50312L20.4417 8.38187C20.8858 8.8259 20.8858 9.54582 20.4417 9.98986L18.3978 12.0338L11.966 5.60195L14.0098 3.55788C14.4538 3.11384 15.1737 3.11384 15.6178 3.55788L17.4966 5.43673L18.5714 4.36188L17.4968 3.28725C17.2023 2.99277 17.2023 2.51533 17.4968 2.22086Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8728 19.0609C2.60426 17.2844 2.76728 14.8004 4.36184 13.2059L10.9949 6.57306L17.4267 13.0049L16.2208 14.2108L13.8089 11.7989C13.4759 11.4659 12.936 11.4659 12.603 11.7989C12.2699 12.132 12.2699 12.6719 12.603 13.0049L15.0148 15.4168L13.8089 16.6227L11.397 14.2108C11.064 13.8778 10.524 13.8778 10.191 14.2108C9.85799 14.5439 9.85799 15.0838 10.191 15.4168L12.6029 17.8287L10.7938 19.6378C9.19937 21.2323 6.71564 21.3954 4.93925 20.1272L3.2873 21.7791C2.99283 22.0736 2.51539 22.0736 2.22091 21.7791C1.92644 21.4847 1.92644 21.0072 2.22091 20.7128L3.8728 19.0609Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.3ea6de792982507d357478bf6bd27767.svg";
export { ForwardRef as ReactComponent };